import App from './website/App'

import {
	HomePage,
	LoginPage,
	ChallengePage,
	RegistryPage,
	AccountVerificationPage,
	LegalPage,
	RecoverPasswordPage,
	TrainersPage
} from './website/pages'

import { DataLoader } from './DataLoader'
import NotFound from './NotFound/NotFound'
import WebApp from './webapp/WebApp'
import {
	WorkoutPage,
	DailyWorkoutPage,
	WeeklyWorkoutPage,
	ResultsPage,
	ProfilePage,
	PlansPage,
	PlanSubscriptionPage,
	UserWeightPage,
	UserDataPage,
	UserChallengePage,
	UserBiometricPage,
	UserBillingPage,
	UserPaymentsPage,
	UserPasswordPage
} from './webapp/pages'


function relativeRouter({ notFoundComponent, finalPathsExact }) {
	return function fixSubRoutes(rawRoutes, upperPath) {
		return rawRoutes.map((ele) => {
			let routes = ele.routes
			if (!ele.path && typeof ele.path !== 'string') {
				return ele
			}
			const path = `${ upperPath || '' }${ ele.path }`
			if (routes) {
				routes = fixSubRoutes(routes, path, notFoundComponent)
				if (notFoundComponent) {
					routes.push({ path: '*', exact: true, component: notFoundComponent })
				}
			} else if (finalPathsExact) {
				ele.exact = true
			}
			return {
				...ele,
				path,
				routes
			}
		})
	}
}

const routes = [
	{
		path: '/:locale([A-Za-z]{2})?',
		component: DataLoader,
		routes: [
			{
				path: '/login',
				component: LoginPage,
				exact: true
			},
			{
				component: WebApp,
				path: '/apt',
				routes: [
					{
						path: '/plans',
						component: PlansPage
					},
					{
						path: '/plan/:id',
						component: PlanSubscriptionPage
					},
					{
						path: '/workout',
						component: WorkoutPage,
						routes: [
							{
								path: '/',
								component: DailyWorkoutPage
							},
							{
								path: '/daily',
								component: DailyWorkoutPage
							},
							{
								path: '/weekly',
								component: WeeklyWorkoutPage
							},
							{
								path: '/results',
								component: ResultsPage
							}
						]
					},
					{
						path: '/profile',
						component: ProfilePage,
						routes: [
							{
								path: '/',
								component: UserDataPage
							},
							{
								path: '/biometric',
								component: UserBiometricPage
							},
							{
								path: '/challenge',
								component: UserChallengePage
							},
							{
								path: '/weight',
								component: UserWeightPage
							},
							{
								path: '/billing',
								component: UserBillingPage
							},
							{
								path: '/subscriptions',
								component: UserPaymentsPage
							},
							{
								path: '/password',
								component: UserPasswordPage
							}
						]
					}
				]
			},
			{
				path: '',
				component: App,
				routes: [
					{
						path: '/',
						component: HomePage
					},
					{
						path: '/challenges/:id',
						component: ChallengePage
					},
					{
						path: '/trainers/:id',
						component: TrainersPage
					},
					{
						path: '/registry',
						component: RegistryPage
					},
					{
						path: '/tos',
						component: LegalPage,
						exact: true
					},
					{
						path: '/password_recovery',
						component: RecoverPasswordPage,
						exact: true
					},
					{
						path: '/account_verification/:token?',
						component:

							AccountVerificationPage
					}

				]
			},
			LegalPage

		]
	}
]

const relativeRouterConfig = {
	notFoundComponent: NotFound,
	finalPathsExact: true
}

export default relativeRouter(relativeRouterConfig)(routes)


// const routes = [
// 	{
// 		path: '/login',
// 		component: LoginPage,
// 		exact: true
// 	},
// 	{
// 		component: WebApp,
// 		path: '/:locale([A-Za-z]{2})?',
// 		routes: [
// 			{
// 				path: '/:locale?/plans',
// 				component: PlansPage
// 			},
// 			{
// 				path: '/apt/plan/:id',
// 				component: PlanSubscriptionPage
// 			},
// 			{
// 				path: '/apt/workout',
// 				component: WorkoutPage,
// 				routes: [
// 					{
// 						path: '/apt/workout',
// 						component: DailyWorkoutPage,
// 						exact: true
// 					},
// 					{
// 						path: '/apt/workout/daily',
// 						component: DailyWorkoutPage
// 					},
// 					{
// 						path: '/apt/workout/weekly',
// 						component: WeeklyWorkoutPage
// 					},
// 					{
// 						path: '/apt/workout/results',
// 						component: ResultsPage
// 					}
// 				]
// 			},
// 			{
// 				path: '/apt/profile',
// 				component: ProfilePage,
// 				routes: [
// 					{
// 						path: '/apt/profile',
// 						component: UserDataPage,
// 						exact: true
// 					},
// 					{
// 						path: '/apt/profile/biometric',
// 						component: UserBiometricPage,
// 						exact: true
// 					},
// 					{
// 						path: '/apt/profile/challenge',
// 						component: UserChallengePage,
// 						exact: true
// 					},
// 					{
// 						path: '/apt/profile/weight',
// 						component: UserWeightPage
// 					},
// 					{
// 						path: '/apt/profile/billing',
// 						component: UserBillingPage
// 					},
// 					{
// 						path: '/apt/profile/payments',
// 						component: UserPaymentsPage
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		component: App,
// 		routes: [
// 			{
// 				path: '/',
// 				component: HomePage,
// 				exact: true
// 			},
// 			{
// 				path: '/challenges/:id',
// 				component: ChallengePage
// 			},
// 			{
// 				path: '/registry',
// 				component: RegistryPage
// 			},
// 			{
// 				path: '/account_verification/:token?',
// 			}

// 		]
// 	}
// ]



// WEBPACK FOOTER //
// ./src/client/routes.js